import { useId, useState } from 'react';
import PropTypes from 'prop-types';

import { Button } from '@utilities';

import styles from './_index.module.scss';

export const COLLAPSIBLE_TABLE_ROW_THRESHOLD = 20;

const CollapsibleTable = ({ children, rowCount }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const contentId = useId();
  const isCollapsible = rowCount >= COLLAPSIBLE_TABLE_ROW_THRESHOLD;

  if (!isCollapsible) return children;

  const toggleLabel = isExpanded ? 'Collapse' : 'Expand';

  return (
    <div>
      <div
        className={isExpanded ? undefined : styles['collapsible-table-content']}
        data-testid="collapsible-table-content"
        id={contentId}
      >
        {children}
        {!isExpanded && <div aria-hidden="true" className={styles['collapsible-table-gradient']} />}
      </div>
      <div className={styles['collapsible-table-toggle']}>
        <Button
          aria-controls={contentId}
          aria-expanded={isExpanded}
          onClick={() => setIsExpanded((currentValue) => !currentValue)}
          text={toggleLabel}
          type="button"
          variant="secondary"
        />
      </div>
    </div>
  );
};

CollapsibleTable.propTypes = {
  children: PropTypes.node.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default CollapsibleTable;
